<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Services publics" />
            <ServicePublic />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ServicePublic from '../Services/ServicePublic'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ServicePublicPage',
    components: {
        NavBar,
        PageTitle,
        ServicePublic,
        FooterComp,
    }
}
</script>